export default __webpack_public_path__ + "_/sounds/incoming_mail-297014417b8431741544a9c6840c096051cf31ef395389d79c791d75644bd53f.mp3";